<template lang="pug">
    v-container.custom-container()
        v-layout(column align-center)
            v-layout(column xs12='' align-center).pt-2.ma-2.mt-3.text-center
                .title(style="color: rgb(76,76,76); font-size: 2.2rem !important; letter-spacing: -1.5px !important;") {{title}}
                v-divider.primary.mt-5( style="width: 100px;")
            v-layout(column style="font-size: 15px;" ).text-xs-justify.pa-3
                p.py-2.text-justify
                  h2.mr-2 Bienvenido a nuestro blog
            v-row(style="width: 100%")
              v-data-iterator(:items="posts" :items-per-page="itemsPerPage" :page="page" style="width: 100%")
                template(v-slot:default="props")
                  v-row
                    v-col(v-for="(item, i) in props.items" :key="item.id" cols="12" md="4" ).cards-col__item
                      v-card(max-width="400").text-center
                        v-img.white--text.align-end(height="200px" :src="item.image")
                          template(v-slot:placeholder="")
                            v-row.fill-height.ma-0(align="center" justify="center")
                              v-progress-circular(indeterminate="" color="primary")
                        v-layout
                          v-flex.justify-center.video-card__title
                            h3.text-center {{item.title}}
                        v-layout
                          v-flex.d-flex.align-center.justify-center
                            span.mt-1.video-card__location.primary--text {{item.type}}
                        v-layout
                          v-flex.d-flex.align-center.justify-center
                            span.mt-1.video-card__location {{item.category}}
                        v-layout.my-3.pa-3
                          v-flex.d-flex.align-center.justify-center
                            v-btn.text-uppercase.mx-auto.video-card__buy(color="primary" small @click="showDetails(item, i)" :loading="isLoading && i === index") Ver mas
</template>

<script>
  export default {
    data () {
      return {
        title: 'News',
        page: 1,
        itemsPerPage: 5,
        isLoading: false,
        index: -1,
      }
    },

    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      posts () {
        return this.$store.getters['cms/getPosts']
      },
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        const vm = this
        vm.$store.commit('cms/setLoading', true)
        vm.$store.dispatch('cms/loadItems', 'posts').then(() => {
          vm.$store.commit('cms/setLoading', false)
        })
      },
      showDetails (item, position) {
        const vm = this
        vm.isLoading = true
        vm.index = position
        vm.$store.dispatch('cms/getItem', { context: 'posts', id: item.id }).then(function () {
          vm.isLoading = false
          vm.index = -1
          vm.$router.replace(`post/${item.id}`)
        })
      },
    },

  }
</script>

<style lang='scss' scoped>

</style>
